import {Component, OnInit} from '@angular/core';
import {ContractObjectBaseComponent} from "../contract-object-base.component";


@Component({
    selector: 'cm-contract-object-side-component',
    templateUrl: 'contract-object-side.component.html',
    standalone: false
})
export class ContractObjectSideComponent extends ContractObjectBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }


}
